export const SYSTEM_FILE_NAMES = ['.DS_Store', 'desktop.ini', 'Thumbs.db'];

export function isNotSystemFile(file: File): boolean {
  return !SYSTEM_FILE_NAMES.includes(file.name);
}
